var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-drawer",
        {
          ref: "addStuDrawer",
          attrs: {
            size: "960px",
            title: _vm.$t("pc_biz_appraise_choose_template" /*选择模板*/),
            visible: _vm.visible,
            "header-border": false,
            "destroy-on-close": "",
            "before-close": _vm.beforeClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.handleClosed,
          },
        },
        [
          _c("yxtbiz-survey-template", {
            attrs: {
              "disabled-create": true,
              selected: _vm.selected && _vm.selected.id,
              type: _vm.modeData.type + 4,
              functionCode: _vm.permission.functionCode,
              dataPermissionCode: _vm.permission.dataPermissionCode,
            },
            on: { select: _vm.templateSelect },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_utility_btn_cancel")))]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.sureHandle } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }